'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getPlainTranslation = exports.getTranslationByKey = exports.getTranslationSearch = exports.getTranslationAccount = exports.getTranslationDeposit = exports.getTranslationRegister = exports.getTranslationLogin = exports.getTranslationLogo = exports.getTranslation = undefined;

var _immutable = require('immutable');

var _reselect = require('reselect');

var getTranslation = exports.getTranslation = function getTranslation(state) {
    return state.getIn(['translation'], (0, _immutable.Map)({}));
};
var getTranslationLogo = exports.getTranslationLogo = function getTranslationLogo(state) {
    return state.getIn(['translation', 'logo'], {});
};
var getTranslationLogin = exports.getTranslationLogin = function getTranslationLogin(state) {
    return state.getIn(['translation', 'login'], {});
};
var getTranslationRegister = exports.getTranslationRegister = function getTranslationRegister(state) {
    return state.getIn(['translation', 'register'], {});
};
var getTranslationDeposit = exports.getTranslationDeposit = function getTranslationDeposit(state) {
    return state.getIn(['translation', 'deposit'], {});
};
var getTranslationAccount = exports.getTranslationAccount = function getTranslationAccount(state) {
    return state.getIn(['translation', 'account'], {});
};
var getTranslationSearch = exports.getTranslationSearch = function getTranslationSearch(state) {
    return state.getIn(['translation', 'search'], {});
};
var getTranslationByKey = exports.getTranslationByKey = function getTranslationByKey(state, key) {
    return state.getIn(['translation', key], {});
};
var getPlainTranslation = exports.getPlainTranslation = (0, _reselect.createSelector)(getTranslation, function (translationsMap) {
    return translationsMap.toJS();
});
//# sourceMappingURL=selectors.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/translation-tokens/dist/main/selectors.js
// module id = 540
// module chunks = 0